import { Box, type BoxProps, Tooltip, type TooltipProps } from "@chakra-ui/react";
import { dayjs } from "@equidefi/i18n";
import type React from "react";

export type LooseAutocomplete<T extends string> = T | Omit<string, T>;
type TimeFormat = LooseAutocomplete<"LT" | "LL" | "LLL" | "llll">;

const formats = new Map<TimeFormat, string>([
  ["LL", "LL"],
  ["LT", "LT"],
  ["LLL", "LLL"],
  ["llll", "llll"],
]);

type DateTimeInput = dayjs.Dayjs | Date | dayjs.ConfigType;

type TooltipTimeProps = BoxProps & {
  datetime: DateTimeInput;
  format?: TimeFormat;
  timeAgo?: boolean;
  tooltip?: TimeFormat;
  tooltipProps?: Omit<TooltipProps, "children">;
};

export const TooltipTime: React.FC<TooltipTimeProps> = ({
  datetime,
  format,
  tooltip,
  timeAgo = false,
  tooltipProps = {},
  ...rest
}) => {
  const time = dayjs.isDayjs(datetime) ? datetime : dayjs(datetime as dayjs.ConfigType);

  const mainFormat = format && formats.has(format) ? formats.get(format) : format;
  const tooltipFormat = tooltip && formats.has(tooltip) ? formats.get(tooltip) : (tooltip as TimeFormat);

  return (
    <Tooltip isDisabled={!tooltip} label={tooltip ? time.format(tooltipFormat as string) : ""} {...tooltipProps}>
      <Box as="time" dateTime={time.toISOString()} {...rest}>
        {timeAgo ? time.fromNow() : time.format(mainFormat as string)}
      </Box>
    </Tooltip>
  );
};
